<template>
  <div id="service" class="service-wrap pt-100 pb-75">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>What's Happening</span>
            <h2>We're Providing Best Services To Our Customers</h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-6 col-md-6"
          v-for="service in services"
          :key="service.id"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="service-card style6">
            <div class="service-info-wrap">
              <div class="service-icon">
                <i :class="service.icon"></i>
              </div>
              <div class="service-info">
                <h3>
                  <router-link to="/service-details">
                    {{ service.title }}
                  </router-link>
                </h3>
                <p>
                  {{ service.shotDesc }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "BestServices",
  data: () => ({
    services: [
      {
        id: 1,
        dataDelay: "200",
        icon: "flaticon-skin-care",
        title: "Face Lifting",
        shotDesc:
          "It is a long established fact that reader will be distract layout.",
      },
      {
        id: 2,
        dataDelay: "300",
        icon: "flaticon-rhinoplasty",
        title: "Rhinoplasty Surgery",
        shotDesc:
          "It is a long established fact that reader will be distract layout.",
      },
      {
        id: 3,
        dataDelay: "400",
        icon: "flaticon-eyelids",
        title: "Eye & Eyelids",
        shotDesc:
          "It is a long established fact that reader will be distract layout.",
      },
      {
        id: 4,
        dataDelay: "500",
        icon: "flaticon-face",
        title: "Facial Treatment",
        shotDesc:
          "It is a long established fact that reader will be distract layout.",
      },
      {
        id: 5,
        dataDelay: "600",
        icon: "flaticon-plastic-surgery",
        title: "Cosmetic Surgery",
        shotDesc:
          "It is a long established fact that reader will be distract layout.",
      },
      {
        id: 5,
        dataDelay: "700",
        icon: "flaticon-weight-loss",
        title: "Laser Treatment",
        shotDesc:
          "It is a long established fact that reader will be distract layout.",
      },
    ],
  }),
});
</script>